import { routes } from '../RouterPath';
import { BreadcrumbsModel } from '../../types/Breadcrumbs/BreadcrumbsModel';

export const editBrandBreadcrumbs = (brandName = '') : BreadcrumbsModel[] => ([
    {
        key: '1',
        value: 'Каталог',
        url: '',
    },
    {
        key: '2',
        value: 'Бренды',
        url: routes.brands,
    },
    {
        key: '3',
        value: brandName,
        url: '',
    },
]);
